export default "__VITE_ASSET__d85ad671__"